import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const cashierSettingState = {
  cashierSettingUI: null,
  cashierAgentLookup: null,
  cashierSettingEffList: null,
};

export const cashierSettingSlice = createSlice({
  name: "cashierSetting",
  initialState: cashierSettingState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    cashierSettingUIFetched: (state, action) => {
      state.actionsLoading = false;
      state.cashierSettingUI = action.payload.data;
    },
    cashierAgentLookupFetched: (state, action) => {
      state.actionsLoading = false;
      state.cashierAgentLookup = action.payload.data;
    },
    cashierSettingManaged: (state) => {
      state.actionsLoading = false;
    },
  },
});
